import axios_nomura from './axios-nomura.services';

export const searchInformation = async (keyword) => {
  return await axios_nomura.get(`api/v1/search?keyword=${encodeURIComponent(keyword)}`);
};
